import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    fetchOrthodontistPreferences,
    updateOrthodontistPreference
} from '../services/orthodontistPreferencesProtocols';
import { ORTHODONTIST_PREFERENCES_KEY } from './queryKeys';

export function useOrthodontistPreferences(orthodontistId: string | undefined) {
    const query = useQuery({
        queryKey: ORTHODONTIST_PREFERENCES_KEY(orthodontistId ?? ''),
        queryFn: () => fetchOrthodontistPreferences(orthodontistId as string),
        enabled: Boolean(orthodontistId),
        staleTime: 60_000
    });

    return {
        preferences: query.data ?? [],
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error
    };
}

interface UpdateOrthodontistPreferenceArgs {
    key: string;
    enabled: boolean;
}

export function useUpdateOrthodontistPreference(orthodontistId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ key, enabled }: UpdateOrthodontistPreferenceArgs) =>
            updateOrthodontistPreference(orthodontistId, key, enabled),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ORTHODONTIST_PREFERENCES_KEY(orthodontistId)
            });
        }
    });
}
